class UIDownloader {
    constructor(rootElement, params) {
        this.rootElement = rootElement;
        this.digitalType = params.digitalType || "";
        this.filesDigital = params.filesDigital || {};
        this.ssoLink = params.ssoLink || "";
        
        this.downloadBtnClickHandle = this.downloadBtnClickHandle.bind(this);
        
        this.init();
    }
    
    init() {
        if (this.digitalType === "audio") {
            this.createAudioButton();
        } else if (this.digitalType === "book") {
            this.createBookButtons();
        }
        this.rootElement.classList.add('ui-downloader_inited');
    }
    
    createAudioButton() {
        const btn = document.createElement('a');
        btn.className = 'ui-downloader__btn ui-btn ui-btn_red';
        if (this.ssoLink) {
            btn.href = this.ssoLink;
            btn.target = '_blank';
        } else {
            btn.classList.add('js-ab-email-collector-action');
            btn.dataset.emailCollectorAction = 'show';
        }
        btn.innerHTML = '<span class="ui-btn__title">Слушать</span>';
        this.rootElement.appendChild(btn);
    }
    
    createBookButtons() {
        const filesLength = Object.values(this.filesDigital).length;
        if (filesLength > 0) {
            const downloadBtn = document.createElement('a');
            downloadBtn.href = 'javascript:;';
            downloadBtn.addEventListener('click', this.downloadBtnClickHandle);
            downloadBtn.className = 'ui-downloader__btn ui-btn ui-btn_white-red';
            downloadBtn.innerHTML = '<span class="ui-btn__title">Скачать</span>';
            this.rootElement.appendChild(downloadBtn);
        }
        
        const readBtn = document.createElement('a');
        readBtn.className = 'ui-downloader__btn ui-btn ui-btn_red';
        if (this.ssoLink) {
            readBtn.href = this.ssoLink;
            readBtn.target = '_blank';
            readBtn.href = this.ssoLink;
        } else {
            readBtn.href = 'javascript:;';
            readBtn.classList.add('js-ab-email-collector-action');
            readBtn.dataset.emailCollectorAction = 'show';
            readBtn.href = 'javascript:;';
        }
        readBtn.innerHTML = '<span class="ui-btn__title">Читать</span>';
        this.rootElement.appendChild(readBtn);
    }
    
    downloadBtnClickHandle() {
        const event = new CustomEvent('ui-downloader.download.click', {
            detail: {
                target: this.rootElement,
                files: this.filesDigital
            },
            bubbles: true,
            cancelable: true
        });
        this.rootElement.dispatchEvent(event);
    }
}
